<script>
  export let height = 1;
</script>

<div style="height: {height}rem" />
